// import Vue from 'vue';
const castTo = (value, castType = 'string') => {
  if (castType === 'string' && typeof value !== 'string' && value.toString()) {
    return value.toString();
  }
  if (castType === 'integer' && parseInt(value, 10).toString() === value) {
    return parseInt(value, 10);
  }
  return value;
};

export default {
  methods: {
    uInt(key, defaultValue = null, prefix = null) {
      const prefKey = prefix ? `${prefix}_${key}` : key;
      if (typeof this.$route.query[prefKey] === 'undefined') return defaultValue;
      const parsed = parseInt(this.$route.query[prefKey], 10);
      if (Number.isNaN(parsed)) return defaultValue;
      return parsed;
    },
    uOpt(key, options = [], defaultValue = null, prefix = null) {
      const prefKey = prefix ? `${prefix}_${key}` : key;
      if (typeof this.$route.query[prefKey] === 'undefined') return defaultValue;
      // eslint-disable-next-line eqeqeq
      const parsed = options.find((o) => (o == this.$route.query[prefKey]) || (o === null && this.$route.query[prefKey] === 'NULL'));
      if (parsed === undefined) return defaultValue;
      return parsed;
    },
    uStr(key, defaultValue = null, prefix = null) {
      const prefKey = prefix ? `${prefix}_${key}` : key;
      if (typeof this.$route.query[prefKey] === 'undefined') return defaultValue;
      return this.$route.query[prefKey];
    },
    uBool(key, defaultValue = false, prefix = null) {
      const prefKey = prefix ? `${prefix}_${key}` : key;
      if (typeof this.$route.query[prefKey] === 'undefined') return defaultValue;
      if (this.$route.query[prefKey] === 'true') return true;
      return false;
    },
    uArr(key, defaultValue = null, prefix = null, castType = 'string') {
      const prefKey = prefix ? `${prefix}_${key}` : key;
      if (typeof this.$route.query[prefKey] === 'undefined') return defaultValue;

      if (!Array.isArray(this.$route.query[prefKey])) {
        if (this.$route.query[prefKey]) return [castTo(this.$route.query[prefKey], castType)];
        return defaultValue;
      }
      return this.$route.query[prefKey].map((value) => castTo(value, castType));
    },
    uQuery(params, blacklist = null, whitelist = null, prefix = null) {
      const newQuery = {};
      if (this.$router.query) {
      // ignore other query parameters: copy them dirrectly it they are not passed
      // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(this.$router.query)) {
          const prefKey = prefix ? `${prefix}_${key}` : key;
          if (!(prefKey in params)) newQuery[key] = value;
        }
      }
      // update new parameters, use whitelist / blacklist
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(params)) {
        if (blacklist && blacklist.includes(key)) continue;
        if (whitelist && !whitelist.includes(key)) continue;
        const prefKey = prefix ? `${prefix}_${key}` : key;
        if (value === null) newQuery[prefKey] = 'NULL';
        else if (value !== '') newQuery[prefKey] = value;
        // if (value !== null && value !== '') newQuery[prefKey] = value;
      }
      return newQuery;
    },
    uReq(params, casts = {}) {
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(params)) {
        if (casts && casts.bool && casts.bool.includes(key)) {
          params[key] = value === true
        || value === 'true' || value === '1' || value === 1 ? 1 : 0;
        }
      }
      return params;
    }
  }
};
